import React, { useState } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { SectionProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Input from '../elements/Input';
import Button from '../elements/Button';
import { sendPasswordReset } from '../../api/auth';

const propTypes = {
  ...SectionProps.types
};

const defaultProps = {
  ...SectionProps.defaults
};

const ForgotPasswordForm = (props) => {
  const [email, setEmail] = useState('');
  const [fieldError, setFieldError] = useState('');
  const [submitMessage, setSubmitMessage] = useState('');
  const [submitError, setSubmitError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    className,
    topOuterDivider,
    bottomOuterDivider,
    topDivider,
    bottomDivider,
    hasBgColor,
    invertColor
  } = props;

  const outerClasses = classNames(
    'signin section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'signin-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const sectionHeader = {
    title: 'Reset your password',
    paragraph: 'Enter your email. If we find a matching email in the system we will send password reset instructions.'
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!email.trim()) {
      setFieldError('Email is required.');
      setSubmitMessage('');
      setSubmitError('');
      return;
    }

    setFieldError('');
    setSubmitError('');
    setIsSubmitting(true);

    try {
      const response = await sendPasswordReset(email.trim());
      console.log('Password reset response', response);
      setSubmitMessage('If we find a matching email in the system we will send password reset instructions.');
    } catch (error) {
      setSubmitMessage('');
      setSubmitError(error.message || 'Request failed');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader tag="h1" data={sectionHeader} className="center-content" />
          <div className="tiles-wrap">
            <div className="tiles-item">
              <div className="tiles-item-inner">
                <form onSubmit={handleSubmit} noValidate>
                  <fieldset>
                    <div className="mb-12">
                      <Input
                        id="forgot-password-email"
                        type="email"
                        name="email"
                        label="Email"
                        placeholder="Email"
                        labelHidden
                        value={email}
                        onChange={(event) => {
                          setEmail(event.target.value);
                          setFieldError('');
                          setSubmitMessage('');
                          setSubmitError('');
                        }}
                        required
                        hint={fieldError}
                        status={fieldError ? 'error' : ''}
                      />
                    </div>

                    {submitError && (
                      <div className="mb-16 text-sm text-color-error">
                        {submitError}
                      </div>
                    )}

                    {submitMessage && (
                      <div className="mb-16 text-sm text-color-low">
                        {submitMessage}
                      </div>
                    )}

                    <div className="mt-24 mb-32">
                      <Button color="primary" wide type="submit" loading={isSubmitting} disabled={isSubmitting}>
                        Send reset instructions
                      </Button>
                    </div>
                  </fieldset>
                </form>
                <div className="signin-bottom has-top-divider">
                  <div className="pt-32 text-xs center-content text-color-low">
                    Remembered your password?{' '}
                    <Link to="/login" className="func-link">
                      Back to login
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

ForgotPasswordForm.propTypes = propTypes;
ForgotPasswordForm.defaultProps = defaultProps;

export default ForgotPasswordForm;
